import { appRoute } from "routes/app/home.runtime"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { AssetRegisters } from "routes/asset-register/asset-registers"
import { AssetRegister } from "routes/asset-register/asset-register"
import { Asset } from "routes/asset-register/asset"
import { checkPermission } from "library/authorization/index.mjs"
import { and } from "lib/logic"
import { getDemandForFeature } from "lib/features"
import { FEATURE_FLAG_ASSET_MAPPING } from "./feature-flag-asset-mapping"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { AddAssets } from "./plugins/excel-import/add-assets"
import { hasDemand } from "lib/authorization/has-demand"
import { AssetRegisterDisplayFields } from "routes/asset-register/asset-register-table/asset-register-column-definitions.mjs"
import { addImportedFromDisplayField } from "routes/asset-register/add-imported-from-display-field"

appRoute.register(
    "assets",
    <DemandGuard demands={[`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`]}>
        <AssetRegisters $lazy />
    </DemandGuard>
)
appRoute.register(
    "asset/:assetId",
    <DemandGuard demands={[`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`]}>
        <Asset $lazy />
    </DemandGuard>
)
appRoute.register(
    "assets/:id",
    <DemandGuard demands={[`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`]}>
        <AssetRegister $lazy />
    </DemandGuard>
)
appRoute.register(
    "assets/:id/:assetId",
    <DemandGuard demands={[`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`]}>
        <Asset $lazy />
    </DemandGuard>
)

appRoute.register(
    "assets/:id/add-assets",
    <DemandGuard demands={[`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`]}>
        <AddAssets />
    </DemandGuard>
)

registerConditionalPageNavigation(
    and(
        () => checkPermission(`$${getDemandForFeature(FEATURE_FLAG_ASSET_MAPPING)}`),
        () => hasDemand("!sharing"),
        () => hasDemand("schedules")
    ),
    `/app/assets`,
    "Asset Registers",
    "healthicons:register-book",
    {
        priority: 140,
        group: "Planning",
        subPaths: true,
    }
)

AssetRegisterDisplayFields.handleOnce(addImportedFromDisplayField)
